import type { ListControlProps } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { TreeSelect as AntdTreeSelect } from 'antd'
import { ListSearchContext } from 'src/components'
import { appStore } from 'src/stores'
import { $api } from 'src/plugins'
import { getNavFieldsFromNavField, getRulesFromNavFilters, generateSimpleTreeData } from 'src/components/root/helper'
import { initFilter, getSingleRule, extendRules, extendInclude } from 'src/utils/common'
import { uniqWith } from 'lodash'

const TreeSelect = (props: ListControlProps) => {
  const search = useContext(ListSearchContext)

  // 树下拉数据
  const [treeData, setTreeData] = useState<any[]>([])
  const onLoadData = (params?: any) => {
    const {
      INPUT_DATA_API: url,
      INPUT_DATA_LEVEL,
      INPUT_FILTER_ORG_TYPE: OrgType,
      INPUT_NAV_FIELD,
      Nav_Filters
    } = props.config
    if (!url) return new Promise(resolve => { resolve(false) })

    const { OrgId } = appStore.current.headers
    const payload: any = initFilter({ OrgId, OrgType })
    payload.Level = params?.id ? 1 : (INPUT_DATA_LEVEL || 0)
    // 搜索过滤字段
    const singleRule = []
    params?.id && singleRule.push(getSingleRule('PARENT_ID', 1, params.id))
    // 菜单参数
    payload.MenuParameter = appStore.current.activeMenu.MENU_FORM_PARAMS
    // navFields 导航字段
    const navFields = getNavFieldsFromNavField(INPUT_NAV_FIELD)
    navFields.length && extendInclude(payload, navFields)
    // 配置的过滤字段
    const filters = getRulesFromNavFilters(Nav_Filters, {
      user: appStore.current.userinfo,
      formBase: search.formBase
    })
    extendRules(payload, singleRule.concat(filters))

    return new Promise((resolve) => {
      $api['app/getDataByPost'](payload, {
        url
      }).then((res: any) => {
        if (res) {
          // 一次性加载全部数据
          if (INPUT_DATA_LEVEL === -1) {
            const simpleData: any[] = []
            generateSimpleTreeData(res, simpleData)
            setTreeData(simpleData)
            return
          }
          const data = res.map((item: any) => ({
            id: item.Node.ID,
            pId: params?.id || undefined,
            title: item.Node.NAME,
            value: item.Node.ID,
            isLeaf: item.IsLeaf
          }))
          setTreeData(prev => {
            return uniqWith(data.concat(prev), (a: any, b: any) => a.id === b.id)
          })
        }
      }).finally(() => {
        resolve(undefined)
      })
    })
  }
  useEffect(() => {
    onLoadData()
  }, [])

  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const { INPUT_DATA_LEVEL, PROMPT_INFO } = props.config
  return (
    <AntdTreeSelect
      allowClear
      treeDataSimpleMode
      value={props.value}
      treeData={treeData}
      loadData={INPUT_DATA_LEVEL !== -1 ? onLoadData : undefined}
      onChange={handleChange}
      placeholder={PROMPT_INFO}
      style={{ width: 183 }}
    />
  )
}

export default TreeSelect